import { Minus, Plus } from "lucide-react"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { LoginModal } from "@/features/auth/components/LoginModal"
import { useAuthStore } from "@/features/auth/store/authStore"
import { useTranslation } from "@/language"
import type { IntentionDetail } from "../types"

interface IntentionHeaderProps {
  intention: IntentionDetail
  isToggling: boolean
  onToggle: () => void
}

export function IntentionHeader({ intention, isToggling, onToggle }: IntentionHeaderProps) {
  const user = useAuthStore(state => state.user)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const { t } = useTranslation("learnPractice")

  const handleToggle = () => {
    if (!user) {
      setShowLoginModal(true)
      return
    }
    onToggle()
  }

  return (
    <div className="md:py-4 mt-1">
      <div className="flex items-center gap-4 flex-wrap">
        <h1 className="text-xl md:text-[30px] leading-normal font-semibold text-white uppercase">
          {intention.name}
        </h1>
        <Button
          onClick={handleToggle}
          disabled={isToggling}
          variant={intention.isSaved ? "default" : "outline"}
          className={`text-[12px] leading-[20px] border border-white uppercase rounded-full ${
            intention.isSaved ? "text-white -ms-1 mb-1" : " text-white !py-4 md:!py-5 !px-3 "
          }`}
          size="xs"
        >
          {intention.isSaved ? (
            <Minus className="h-4 w-4" />
          ) : (
            <>
              <Plus className="h-4 w-4 mr-1.5" />
              <span className="hidden md:flex">{t("detail.addToIntentions")}</span>
              <span className="md:hidden">{t("detail.add")}</span>
            </>
          )}
        </Button>
      </div>
      {intention.description && (
        <p className="mt-3 text-sm leading-5.5 text-primary max-w-2xl">{intention.description}</p>
      )}
      <LoginModal open={showLoginModal} onOpenChange={setShowLoginModal} />
    </div>
  )
}
